import { useEffect, useState } from "react";
import axios from "axios";

const FormStatus = () => {
  const [loading, setLoading] = useState(true);
  const [isEnabled, setIsEnabled] = useState(false);

  const getFormStatus = async () => {
    try {
      const { data } = await axios.get(
        "https://admissions.swec.ac.in/api/form-status/Admissions"
      );
      setIsEnabled(data?.isEnabled);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const updateFormStatus = async (status) => {
    try {
      await axios.put(
        "https://admissions.swec.ac.in/api/form-status/Admissions",
        {
          isEnabled: status,
        }
      );
      setIsEnabled(status);
    } catch (error) {
      console.error(error);
    }
  };

  const toggleFormStatus = async () => {
    try {
      const { data } = await axios.patch(
        "https://admissions.swec.ac.in/api/form-status/Admissions/toggle"
      );
      setIsEnabled(data.isEnabled);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getFormStatus();
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container mt-5">
      <div className="card p-4">
        <h3>Admissions Form Status</h3>

        <h5 className={isEnabled ? "text-success" : "text-danger"}>
          {isEnabled ? "Enabled" : "Disabled"}
        </h5>

        <div className="mt-3">
          <button
            className="btn btn-success me-2"
            onClick={() => updateFormStatus(true)}
          >
            Enable
          </button>

          <button
            className="btn btn-danger me-2"
            onClick={() => updateFormStatus(false)}
          >
            Disable
          </button>

          <button
            className="btn btn-primary"
            onClick={toggleFormStatus}
          >
            Toggle
          </button>
        </div>
      </div>
    </div>
  );
};

export default FormStatus;